/* eslint-disable react/jsx-no-target-blank */
import React,{ useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../../setup/redux/RootReducer'

//icon
import survey from '../../../../assets/svg/sidebar-icon/survey.svg'
import media from '../../../../assets/svg/sidebar-icon/media.svg'
import event from '../../../../assets/svg/sidebar-icon/event.svg'
import disease from '../../../../assets/svg/sidebar-icon/disease.svg'
import content from '../../../../assets/svg/sidebar-icon/content.svg'
import dashboard from '../../../../assets/svg/sidebar-icon/dashboard.svg'
import user from '../../../../assets/svg/sidebar-icon/user.svg'

export function AsideMenuMain() {
  const [role,setRole]=useState<number>(0)
  const intl = useIntl()

  const userData: any = useSelector<RootState>(
    ({ auth }) => auth?.user,
    shallowEqual,

  )
  //console.log(userData.data.role.id);

  useEffect(() => {
    if (userData) {
      console.log(userData)
      setRole(userData?.data?.role?.role_id)
    }
  }, [userData])
  
  return (
    <>
         <div style={{ marginBottom: "60px" }}>
        {" "}
        {/* dashboard  */}
        <AsideMenuItem
          to="/dashboard"
          icon={dashboard}
          title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
          fontIcon="bi-app-indicator"
        />
        
       <AsideMenuItem
          to="/user"
          icon={user}
          title="User"
          fontIcon="bi-layers"
        />
        <AsideMenuItem
          to="/content"
          icon={content}
          title="Content"
          fontIcon="bi-layers"
        />
         <AsideMenuItem
          to="/survey"
          icon={survey}
          title="Survey"
          fontIcon="bi-layers"
        />
        
        <AsideMenuItem
          to="/media"
          icon={media}
          title="Media"
          fontIcon="bi-layers"
        />

       <AsideMenuItem
          to="/event"
          icon={event}
          title="Event"
          fontIcon="bi-layers"
        />

       <AsideMenuItem
          to="/generic-group"
          icon={disease}
          title="Generic Group"
          fontIcon="bi-layers"
        />

       <AsideMenuItem
          to="/products"
          icon={disease}
          title="Products"
          fontIcon="bi-layers"
        />

       <AsideMenuItem
          to="/disease-pest"
          icon={disease}
          title="Disease"
          fontIcon="bi-layers"
        />
       
       <AsideMenuItem
          to="/disease-detection"
          icon={disease}
          title="Disease Detection"
          fontIcon="bi-layers"
        />
       
      
       

        {/* <AsideMenuItemWithSub
          to=""
          title="Managers"
          fontIcon="bi-chat-left"
          icon="/media/icons/duotune/sidebarIcon/managers.svg"
        >
          <AsideMenuItem
            to="/managers/admin"
            title="Admins"
            hasBullet={true}
          />
          <AsideMenuItem
            to="/managers/supervisor"
            title="Supervisors"
            hasBullet={true}
          />
        </AsideMenuItemWithSub> */}
        
     
        {/* <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div> */}
        {/* <AsideMenuItem to="/my-page" title="My Page" />*/}
      </div>

    </>
  )
}
